// Adds data-label attributes to article table cells based on the header row.
// Used by the mobile breakpoint in fabriculture-custom.css to render each
// row as a stacked card with "Header: value" pairs (sane on narrow screens).
(function () {
  function label(table) {
    if (!table || table.dataset.fcLabeled) return;
    var headers = [];
    table.querySelectorAll('thead th, thead td').forEach(function (h) {
      headers.push((h.innerText || h.textContent || '').trim());
    });
    if (!headers.length) {
      // Some sources put header row in tbody — use the first row as headers
      var firstRow = table.querySelector('tbody tr');
      if (firstRow) {
        firstRow.querySelectorAll('th, td').forEach(function (h) {
          headers.push((h.innerText || h.textContent || '').trim());
        });
      }
    }
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var cells = tr.children;
      // Detect "category divider" rows: first cell populated, second empty
      var isDivider = cells.length >= 2 &&
        (cells[0].innerText || '').trim() !== '' &&
        (cells[1].innerText || '').trim() === '';
      if (isDivider) {
        tr.setAttribute('data-fc-divider', '');
      } else {
        for (var i = 0; i < cells.length; i++) {
          var lab = headers[i] || '';
          if (lab) cells[i].setAttribute('data-label', lab);
        }
      }
    });
    table.dataset.fcLabeled = '1';
  }

  function run() {
    document.querySelectorAll('.article-template__content table').forEach(label);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
